import { Pipe, PipeTransform } from '@angular/core'
import { toUnderscore } from '@adex/shared/utils/text'


@Pipe({
  name: 'toUnderscore',
  pure: true
})
export class ToUnderscorePipe implements PipeTransform {

  public transform(target: string): string {
    return toUnderscore(target)
  }

}
